import { Button, Dropdown as DropdownBase, Menu as MenuBase } from "antd";

import { Dictionary } from "../../interfaces";
import { LogoutAction } from "../../actions/auth";
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { User } from "../../reducers/auth";
import { UserOutlined } from "@ant-design/icons";

// ponytail: antd4's Dropdown/Menu*Props predate React 18's stricter children typing; cast until antd5 migration
const Dropdown: any = DropdownBase;
const Menu: any = MenuBase;

interface Props {
  isFetching: boolean;
  labels: Dictionary<string>;
  user: User | null;
  openUserProfile: () => void;
  onLogout: () => LogoutAction;
}
const LogoutBtn: React.FC<Props> = (props) => {
  const { user, labels, isFetching, openUserProfile, onLogout } = props;

  const menu = (
    <Menu>
      <Menu.Item key="profile" title="Profile" onClick={openUserProfile}>
        <a>{labels.profile}</a>
      </Menu.Item>
      <Menu.Item title="Privacy policy">
        <a href="/privacy-policy.pdf" target="_blank">
          {labels.privacyPolicy}
        </a>
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      {user && (
        <Dropdown.Button
          overlay={menu}
          placement="bottomCenter"
          icon={<UserOutlined />}
        >
          {/* {user.firstName} */}
        </Dropdown.Button>
      )}
      {user && (
        <Button
          className="logout-button"
          onClick={() => onLogout()}
          loading={isFetching}
        >
          Log out
        </Button>
      )}
    </>
  );
};

export default LogoutBtn;
